module.exports = __webpack_public_path__ + "static/media/gas_emission.5def3736.png";